import { CategoryCreate } from "./categoryCreate";
import { CategoryEdit } from "./categoryEdit";
import { CategoryList } from "./categoryList";

export default {
	create: CategoryCreate,
	edit: CategoryEdit,
	list: CategoryList,
};
